import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../components/Login.vue';

/* 
Rutas Admin 
*/
import DashBoardAdmin from '../components/Admin/DashBoardAdmin';
import Areas from '../components/Admin/Areas';
import Usuarios from '../components/Admin/Usuarios';
import Roles from '../components/Admin/Roles';

//Rutas Compras
import DashBoardCompras from '../components/Compras/DashBoardCompras.vue';
import ProcesosCompras from '../components/Compras/Procesos.vue';
import ProcesosFinalizadosCompras from '../components/Compras/ProcesosFinalizados.vue';
import ProcesosComprasRealizar from '../components/Compras/ProcesosPorComprar.vue';
import AvancesProcesos from '../components/Compras/AvancesProcesos.vue';
import TodosProcesos from '../components/Compras/todosProcesos.vue';
import gestionProveedor from '../components/Compras/gestionProveedor.vue';
import CalificacionProveedor from '../components/Compras/CalificacionProveedor.vue';

/* 
Rutas Director area
*/
import DashBoardDirectorArea from '../components/DirectorArea/DashBoardDirectorArea.vue';
import Procesos from '../components/DirectorArea/Procesos.vue';
import PdfDirectorArea from '../components/DirectorArea/VerPdfDirectorArea';
import CalificarProveedor from '../components/DirectorArea/CalificarProveedor';

/* 
Rutas Gerente area
*/
import DashBoardGerenteArea from '../components/GerenteArea/DashBoardGerenteArea.vue';
import PdfGerente from '../components/GerenteArea/VerPdfGerente';

/*
Rutas Control interno 
*/
import DashBoardControlInterno from '../components/ControlInterno/DashBoardControlInterno.vue';
import ProcesosInternoFacilisimo from '../components/ControlInterno/ProcesosInternoFacilisimo.vue';
import ProcesosInternoApostar from '../components/ControlInterno/ProcesosInternoApostar.vue';
import todosProcesos from '../components/ControlInterno/todosProcesos.vue';
import VerPdfControlInterno from '../components/ControlInterno/VerPdfControlInterno.vue';
import CrearProceso from '../components/ControlInterno/CrearProceso.vue';
import CalificarProveedorCI from '../components/ControlInterno/CalificarProveedor.vue';


//RUTAS REVISION
import DashBoardRevision from '../components/Revision/DashBoardRevision.vue';
import procesosRevision from '../components/Revision/procesosRevision.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  // Administrador
  {
    path: '/Admin',
    component: DashBoardAdmin,
    meta: {
      requiresAuth: true,
      roles: [1] // Solo Administrador
    },
    children: [
      { path: '', component: Usuarios },  // Redirige a Usuarios por defecto
      { path: 'Areas', component: Areas },
      { path: 'Usuarios', component: Usuarios },
      { path: 'Roles', component: Roles }
    ]
  },
  // Compras
  {
    path: '/Compras',
    component: DashBoardCompras,
    meta: {
      requiresAuth: true,
      roles: [3] // Solo Compras
    },
    children: [
      { path: '', component: ProcesosCompras },  // Redirige a Procesos por defecto
      { path: 'Procesos', component: ProcesosCompras },
      { path: 'ProcesosFinalizados', component: ProcesosFinalizadosCompras },
      { path: 'AvancesProcesos', component: AvancesProcesos },
      { path: 'ProcesosPorComprar', component: ProcesosComprasRealizar },
      { path: 'TodosProcesos', component: TodosProcesos },
      { path: 'gestionProveedor', component: gestionProveedor },
      { path: 'CalificacionProveedor', component: CalificacionProveedor }
    ]
  },
  // Director Area
  {
    path: '/DirectorArea',
    component: DashBoardDirectorArea,
    meta: {
      requiresAuth: true,
      roles: [2] // Solo Director de Área
    },
    children: [
      { path: '', component: Procesos },  // Redirige a Procesos por defecto
      { path: 'Procesos', component: Procesos },
      { path: 'PdfDirectorArea', component: PdfDirectorArea },
      { path: 'CalificarProveedor', component: CalificarProveedor }
    ]
  },
  // Gerente Area
  {
    path: '/Gerente',
    component: DashBoardGerenteArea,
    meta: {
      requiresAuth: true,
      roles: [5] // Solo Gerente
    },
    children: [
      { path: '', component: PdfGerente },  // Redirige a PdfGerente por defecto
      { path: 'PdfGerente', component: PdfGerente }
    ]
  },
  // Control Interno
  {
    path: '/ControlInterno',
    component: DashBoardControlInterno,
    meta: {
      requiresAuth: true,
      roles: [4] // Solo Control Interno
    },
    children: [
      { path: '', component: ProcesosInternoFacilisimo },  // Redirige a ProcesosInternoFacilisimo por defecto
      { path: 'ProcesosInternoFacilisimo', component: ProcesosInternoFacilisimo },
      { path: 'ProcesosInternoApostar', component: ProcesosInternoApostar },
      { path: 'TodosProcesos', component: todosProcesos },
      { path: 'CrearProceso', component: CrearProceso },
      { path: 'VerPdfControlInterno', component: VerPdfControlInterno },
      { path: 'CalificarProveedor', component: CalificarProveedorCI }
    ]
  },
  // Revision
  {
    path: '/Revision',
    component: DashBoardRevision,
    meta: {
      requiresAuth: true,
      roles: [6] // Solo Revisión
    },
    children: [
      { path: '', component: procesosRevision },  // Redirige a procesosRevision por defecto
      { path: 'procesosRevision', component: procesosRevision }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// Proteger Rutas
router.beforeEach((to, from, next) => {
  const idRol = parseInt(localStorage.getItem('rol'), 10); // Obtener idRol como número

  const autorizacion = to.matched.some(record => record.meta.requiresAuth); // Verificar si la ruta requiere autenticación

  if (autorizacion) {
    if (!idRol) {
      next('/'); // Redirigir al login si no está autenticado
    } else {
      // Verificar si el rol es Administrador (idRol = 1)
      if (idRol === 1) {
        next(); // Permitir acceso a todas las rutas si es Administrador
      } else {
        const rolesPermitidos = to.matched.some(record => {
          return record.meta.roles && record.meta.roles.includes(idRol);
        });

        if (rolesPermitidos) {
          next(); // Permitir acceso si el idRol está permitido
        } else {
          alert('Acceso Denegado: No tienes permiso para acceder a esta página');
          router.go(-1); // Navegar a la página anterior en el historial
        }
      }
    }
  } else {
    next(); // Permitir acceso si no requiere autenticación
  }
});

export default router;
